import { AppState } from 'react-native';
import ExpoConstants from 'expo-constants';
import * as Updates from 'expo-updates';
import Constants from 'src/core/utils/Constants';
import useAppStateGlobalListener from 'src/presentation/hooks/useAppStateGlobalListener';

let hasUpdate = false;

const canCheckForUpdates = () => ExpoConstants.appOwnership !== Constants.appOwnershipExpo;

function checkForUpdates(): void {
	if (!canCheckForUpdates()) {
		console.info('Running in Expo Client, not checking for updates.');

		return;
	}

	Updates.checkForUpdateAsync()
		.then(async (update) => {
			if (update.isAvailable) {
				console.info('[EXPO] Updating app!');
				await Updates.fetchUpdateAsync();
				hasUpdate = true;
			}
		})
		.catch(() => {
			// Not reported: the next foregrounding checks again.
		});
}

function reloadIfUpdatePending(): void {
	if (!canCheckForUpdates() || !hasUpdate || AppState.currentState !== Constants.appStateBackground) {
		return;
	}

	hasUpdate = false;
	console.info('[EXPO] Updating app in background!');

	Updates.reloadAsync().catch(() => {
		// The bundle stays on the device, so the next cold start applies it anyway.
	});
}

export default function Updater() {
	useAppStateGlobalListener({
		onInit: checkForUpdates,
		onForegrounded: checkForUpdates,
		onBackgrounded: reloadIfUpdatePending,
	});

	return null;
}
